$(document).ready(function(){

    $(document).on('click','.complementary-products li',function(e) {              
      $(this).toggleClass('active');    
      if($('.complementary-products li.active').length > 0){
        $('.product .product-form__buttons button.product-form__submit').addClass('active_addons'); 
      }
      else{
        $('.product .product-form__buttons button.product-form__submit').removeClass('active_addons'); 
      }
    });
    $(document).on('click','.product-form__buttons',function(e) {
      e.preventDefault();
      e.stopPropagation();
      $('cart-drawer.drawer').removeClass('is-empty');
       $('.product .product-form__buttons button.product-form__submit').addClass('loading');
      $(this).find('.loading__spinner.hidden').removeClass('hidden');
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var main_id = $(this).parents('form').find('input[name="id"]').val();
      var qty = $(this).parents('.product__info-wrapper').find('input[name="quantity"]').val();
      console.log(qty);
      var $this = $(this);
      var array = [];
      array.push({ id: main_id, quantity: qty });
      $('.complementary-products li.active').each(function(){
          var id = $(this).attr('data-id');
          array.push({ id: id, quantity: 1 });
      });
      console.log(array);
      $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify({
              items: array,
              sections: cart.getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname
          }),
          contentType: 'application/json', 
          dataType: 'json',
          success: function(response) {
              console.log('success',response);
              cart.renderContents(response);
              $this.find('.loading__spinner').addClass('hidden');
             $('.product .product-form__buttons button.product-form__submit').removeClass('loading');
            
          },
          error: function(xhr, status, error) {
              console.error('Error:', error);
             $('.product .product-form__buttons button.product-form__submit').removeClass('loading');
              $this.find('.loading__spinner').addClass('hidden');
            
          }
      });
    });
  
});  